import { Exit, GetExitFromString } from "slotworks/state-machine/data/exit";
import Node from "slotworks/state-machine/data/node";
import { DecisionConfig, NodeConfig, StateConfig, StateMachineConfig, SuperStateConfig } from "slotworks/state-machine/parser/config/state-machine-config-schema";
import { StateMachine } from "slotworks/state-machine/state-machine";
import StateRegister from "slotworks/state-machine/state-register";
import { parseJSONMap } from "slotworks/utils/json-utils";
abstract class StateParser {

    public static parse(config: string | object, stateMachine: StateMachine): Node {
        const stateMachineConfig: StateMachineConfig = typeof config === "string" ? JSON.parse(config) : config as StateMachineConfig;

        let allNodeConfigs: NodeConfig[] = [].concat(stateMachineConfig.states, stateMachineConfig.decisions, stateMachineConfig.superStates);
        allNodeConfigs = allNodeConfigs.filter((nodeConfig) => nodeConfig !== undefined);

        allNodeConfigs.map((node) => {
            if (!node.hasOwnProperty("links")) {
                throw new Error("State Machine node with no links detected: " + node.id);
            }

            const linkMap = parseJSONMap<string>(node.links);

            node.linksMap = linkMap;
        });

        const nodes: Map<string, Node> = new Map<string, Node>();

        this.generateNodes(allNodeConfigs, stateMachine, nodes);

        this.generateLinks(allNodeConfigs, nodes);

        if (!nodes.get("default")) {
            throw new Error("No entry point found in state config");
        }

        return nodes.get("default");
    }

    private static generateNodes(nodeConfigs: NodeConfig[], stateMachine: StateMachine, generatedNodes: Map<string, Node>) {
        nodeConfigs.map((nodeConfig: NodeConfig) => {
            let generatedConcrete;

            try {
                generatedConcrete = StateRegister.get((nodeConfig as DecisionConfig).concrete);
            } catch (e) {
                try {
                    generatedConcrete = StateRegister.get(nodeConfig.id);
                } catch (e) {
                    throw e;
                }
            }

            const params = nodeConfig.hasOwnProperty("params") ? (nodeConfig as StateConfig).params : null;
            const cascadeSkip = nodeConfig.hasOwnProperty("cascadeSkip") ? (nodeConfig as StateConfig).cascadeSkip : null;
            const turboSkip = nodeConfig.hasOwnProperty("turboSkip") ? (nodeConfig as StateConfig).turboSkip : null;
            const subState = nodeConfig.hasOwnProperty("entrySubState") ? generatedNodes.get((nodeConfig as SuperStateConfig).entrySubState) : null;

            const generatedNode = new Node(nodeConfig.id, generatedConcrete, params, cascadeSkip, turboSkip, subState);

            generatedNodes.set(nodeConfig.id, generatedNode);

            if (nodeConfig.entryPoint) {
                generatedNodes.set("default", generatedNode);
            }
        });
    }

    private static generateLinks(nodeConfigs: NodeConfig[], nodes: Map<string, Node>) {
        nodeConfigs.map((nodeConfig: NodeConfig) => {
            nodeConfig.linksMap.forEach((link: string, key: string) => {
                const exit = GetExitFromString(key);
                const target: Node | string = nodes.has(link) ? nodes.get(link) : link;

                nodes.get(nodeConfig.id).addLink(exit === Exit.Custom ? key : exit, target);
            });
        });
    }
}

export default StateParser;
